import { cn } from "@/lib/cn";

/**
 * Single skeleton block. Composes into rows for table-style placeholders.
 *
 * No CSS animation by default — operator density tolerates a static
 * shimmer-free skeleton, and animated bars are visually noisy across
 * dense rows. Pass `pulse` for the slow-pulse variant when used in
 * larger panel hero placeholders.
 */
export function Skeleton({
  className,
  pulse = false,
}: {
  className?: string;
  pulse?: boolean;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-block rounded bg-bg-elev/70",
        pulse && "animate-pulse",
        className,
      )}
    />
  );
}

/** Helper to render a row of N skeleton cells inside a sized container. */
export function SkeletonRow({
  cells = 4,
  className,
}: {
  cells?: number;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      {Array.from({ length: cells }).map((_, i) => (
        <Skeleton key={i} className="h-3 flex-1" />
      ))}
    </div>
  );
}
